export const AUTH_ROUTES = {
  //USERS
  REGISTER_USER: `/users`,
  LOGIN_USER: `/users/login`,
  GET_USER: (userId) => `/users/get-user?_id=${userId}`,
  UPDATE_USER: (userId) => `/users/update-user/${userId}`,
  FORGOT_PASSWORD: `/users/forgot-password`,
  VERIFY_CODE: `/users/verify-email`,
  FORGOT_PASSWORD_NEW: `/users/password`,

  VERIFY_PAYMENT: `/users/order`,
  VERIFY_PAYMENT_PUBLIC: `/users/order/public-verify`,
  GET_PAYMENT_RECORD: (
    paymentId,
    estateId,
    { limit = 10, skip = 0, commodityType } = {},
  ) =>
    `/users/payment-record?userId=${paymentId}&sort=desc&limit=${limit}&skip=${skip}${estateId ? `&estateId=${estateId}` : ``}${commodityType ? `&commodityType=${commodityType}` : ``}`,

  INITIALIZE_PAYMENT: `/users/order/initiate`,
  CHECKOUT_QUOTE: `/users/order/quote`,
  UPDATE_SUPPORT: `/users/create-message`,
  GET_MESSAGE: (estateId) =>
    `/users/get-message?sort=desc${estateId ? `&estateId=${estateId}` : ``}`,
  DELETE_MESSAGE: (msgId) => `/users/delete-response/${msgId}`,
  USER_SEND_RESPONSE: (id) => `/users/send-response/${id}`,

  GET_NOTIFICATION: `/users/notifications?sort=desc`,
  MARK_AS_READ: (id) => `/users/read-notification/${id}`,
  GET_DATA_SERVICES_IDS: `/vtu/service-data-ids`,
  GET_DATA_SERVICE_VARIANTS: `/vtu/service-data-variants`,
  GET_TV_SERVICE_IDS: `/vtu/service-tv-ids`,
  GET_TV_SERVICE_VARIANTS: `/vtu/service-tv-variants`,
  GET_ELECTRICITY_SERVICE_IDS: `/vtu/service-electricity-ids`,
  VERIFY_METER: `/vtu/verify-meter`,
  GET_VTU_TRANSACTIONS: `/vtu/transactions`,
  CREATE_VTU_COMPLAINT: `/vtu/complaints`,
  VTU_PAY_INITIATE: `/vtu/pay-initiate`,
  VTU_PAY_VERIFY: `/vtu/pay-verify`,

  GET_INSURANCE_VARIANTS: `/vtu/service-data-variants`,
  GET_INSURANCE_COLORS: `/vtu/insurance/colors`,
  GET_INSURANCE_ENGINE_CAPACITY: `/vtu/insurance/engine-capacity`,
  GET_INSURANCE_STATES: `/vtu/insurance/states`,
  GET_INSURANCE_LGAS: (stateCode) => `/vtu/insurance/lgas/${stateCode}`,
  GET_INSURANCE_BRANDS: `/vtu/insurance/brands`,
  GET_INSURANCE_MODELS: (makeCode) => `/vtu/insurance/models/${makeCode}`,

  VERIFY_JAMB_PROFILE: `/vtu/education/verify-jamb-profile`,

  GET_DASHBOARD_DATA: (commodity, estateId) =>
    `/users/dashboard?commodity=${commodity}${estateId ? `&estateId=${estateId}` : ``}`,

  // FAQ
  GET_FAQ: `/users/get-faq`,

  // COUPONS
  VALIDATE_COUPON: (code, commodityType, estateId) =>
    `/users/coupon/validate?code=${code}&commodityType=${commodityType}&estateId=${estateId}`,
  // POST /coupon/redeem removed (Checkpoint 2C) — fully-coupon-covered
  // purchases now go through INITIALIZE_PAYMENT like every other purchase.

  // METER
  CLEAR_TAMPER: `/users/meter/clear-tamper`,

  // Bill status polling — returns { status, processingState, token, updatedAt }
  GET_BILL_STATUS: (billId) => `/users/order/${billId}/status`,
};
